/*
ajax请求函数模块
返回值: promise对象(异步返回的数据是: response.data)
 */
import axios from 'axios'
import router from './../router'
import { Message,Loading } from 'element-ui'; //引入加载动画

let loading;
//加载开始
function startLoading() {
  loading = Loading.service({
    lock: true,
    background: 'rgba(0,0,0,.7)'
  });
}
//加载结束
function endLoading() {
  loading.close();
}

axios.defaults.withCredentials = true;
var instance = axios.create({
  baseURL: '',
  timeout: 10000,
  crossDomain:true,
  withCredentials:true
});

//请求拦截
//axios.interceptors.request.use( config => {
instance.interceptors.request.use( config => {
  //加载动画
  startLoading();
  if(localStorage.getItem("zero_token")){
    //配置同意请求头
    config.headers['Access-Token'] = localStorage.zero_token;
  }
  return config;
},error => {
  return Promise.reject(error);
});

//响应拦截
//axios.interceptors.response.use( response => {
instance.interceptors.response.use( response => {
  //结束加载动画
  endLoading();
  console.log(response.data.hasPermission);
  if(response.data.hasPermission == "0"){
    Message.error("没有权限");
  }
  if(response.data.status == -1){
    //localStorage.removeItem('zero_token');
    localStorage.clear();
    router.push("/log");
  }
  return response;
}, error => {
  endLoading();
  //Message.error(error.response.data);

  //获取错误状态码
  const status = error.response;
  if(status == 401){
    Message.error("token过期");
    //清除token
    localStorage.removeItem('zero_token');
    //跳转到登录页
    //router.push("/");
  }
  return Promise.reject(error);
});
//export default axios;

export default  function ajax(url, data = {}, type = 'GET') {
  return new Promise(function (resolve, reject) {
    // 执行异步ajax请求
    let promise;
    if (type === 'GET') {
      // 准备url query参数数据
      let dataStr = '' //数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      });
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'));
        url = url + '?' + dataStr
      }
      // 发送get请求
      promise = instance.get(url)
    } else {
      // 发送post请求
      promise = instance.post(url, data);
    }
    promise.then(function (response) {
      // 成功了调用resolve()
      //console.log(response.headers);
      resolve(response.data)
    }).catch(function (error) {
      //失败了调用reject()
      reject(error)
    })
  })
}

/*
const response = await ajax()
const result = response.data

const resule = await ajax()
 */



// WEBPACK FOOTER //
// ./src/api/ajax.js